import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Less } from '@/views/Bera/_components/Filter/Fields/TotalBera/Less';
import { Greater } from '@/views/Bera/_components/Filter/Fields/TotalBera/Greater';
import { ComparisonField } from '@/views/Bera/_components/Filter/Fields/ComparisonField';

import type { BeraFilterFormFields } from '@/views/Bera/types';

const { useFormInstance } = Form;

export function TotalBERA(): JSX.Element {
	const form = useFormInstance<BeraFilterFormFields>();

	function handleClear(): void {
		const clearedFields = { min_overall_score: undefined, max_overall_score: undefined };

		form.setFieldsValue(clearedFields);
	}

	return (
		<ComparisonField
			name="type_overall_score"
			label={I18n.get('Total B.E.R.A.')}
			minimum={<Greater />}
			maximum={<Less />}
			onClear={handleClear}
		/>
	);
}
